import * as React from "react";
import Box from "@mui/material/Box";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { Control, useController } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { PatientFormValues } from "../patient-form.component";

type LastNameFieldProps = {
  control: Control<PatientFormValues, object>;
};

export default function LastNameField({ control }: LastNameFieldProps) {
  const {
    field,
    formState: { errors },
  } = useController({
    name: "last_name",
    control,
    rules: {
      required: "Last Name is required",
      pattern: {
        value: /^[a-z ,.'-]+$/i,
        message: "Last Name is not valid.",
      },
    },
  });
  return (
    <Box display="flex" justifyContent="space-between">
      <PersonOutlineOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} />
      <TextField
        fullWidth
        label="Last Name"
        required
        {...(Boolean(errors?.last_name?.message)
          ? { error: true, helperText: errors?.last_name?.message }
          : {})}
        {...field}
      />
    </Box>
  );
}
